module.exports = __webpack_public_path__ + "img/pf-b.9f7b6932.png";